import { createAction, props } from '@ngrx/store';

export const setDateRange = createAction(
  '[EventQueryCommand] Set date range',
  props<{ from: Date; to: Date, dateRange: string }>()
);

export const setLocation = createAction(
  '[EventQueryCommand] Set location',
  props<{ location: string }>()
);
export const setLocationGroups = createAction(
  '[EventQueryCommand] Set location group filter',
  props<{
    locations: string[];
  }>()
);

export const setFavoriteEventBtnId = createAction(
  '[EventQueryCommand] Set fav event btn id',
  props<{ favBtnId: string; updateURL?: boolean }>()
);

export const setSearchText = createAction(
  '[EventQueryCommand] Set search text',
  props<{ search: string }>()
);

export const setFavoriteEventBtnIds = createAction(
  '[EventQueryCommand] Set fav event btn ids',
  props<{ favBtnIds: string; matchAllCategories?: boolean; choice?: boolean }>()
);

export const setIsChoice = createAction(
  '[EventQueryCommand] Set is editor choice',
  props<{ choice: boolean | null }>()
);

export const setLockedBaseCategory = createAction(
  '[EventQueryCommand] Set locked base category',
  props<{ lockedCategoryId: string }>()
);
